import m, {Vnode, VnodeDOM} from "mithril";
import TextSelection from "./TextSelection";
import {Questionary} from "../../../model/questionary";

export default class TextSelectionComment
{
    constructor(
        public readonly questionary: Questionary,
        private readonly textSelection: TextSelection,
        private readonly onCloseComment: () => void // there should be saving
    ) { }

    private viewTextarea(): Vnode {
        return m('textarea', {
            oninput: (e: InputEvent) => {
                const comment = (<HTMLInputElement>e.currentTarget).value.trim();
                this.textSelection.comment = comment === '' ? null : comment;
            },
            oncreate: (vnodeDOM: VnodeDOM) => {
                const textarea = <HTMLInputElement>vnodeDOM.dom;
                textarea.value = this.textSelection.comment ? this.textSelection.comment : '';
                textarea.focus();
            },
            onkeydown: (e: KeyboardEvent) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    this.onCloseComment();
                }
            },
            onchange: (e: InputEvent) => {
                const comment = (<HTMLInputElement>e.currentTarget).value.trim();
                this.textSelection.comment = comment === '' ? null : comment;
            }
        });
    }

    private viewControls(): Vnode {
        return m('.TextSelectionComment-controls', {}, [
            m('button.btn.raised.primary', {
                onclick: (e: MouseEvent) => {
                    // Save is in textarea - onchange
                    this.onCloseComment(); // and close
                },
            }, [
                m('i.icon.icon-check-simple.text-light'),
                m('span', {}, this.questionary.renderText(this.questionary.messages.get('saveComment')))
            ]),
            m('span.delete', {
                onclick: (e: MouseEvent) => {
                    this.textSelection.comment = null;
                    this.onCloseComment();
                },
            }, [
                m('i.icon.icon-delete'),
            ]),
        ]);
    }

    view(): Vnode {
        return m('.TextSelectionComment-wrapper', {
            onclick: (e: MouseEvent) => {
                e.stopPropagation();
                this.onCloseComment();
            },
        }, [
            m('.TextSelectionComment', {
                onclick: (e: MouseEvent) => {
                    e.stopPropagation();
                },
            }, [
                m('label', {}, this.questionary.renderText(this.questionary.messages.get('whyDidYouMarkThisText'))),
                this.viewTextarea(),
                this.viewControls(),
            ])
        ]);
    }



}